export default class SiteGroupResource {
  constructor(client) {
    this.client = client;
  }

  list() {
    return this.client.get("/site_groups").then((resp) => resp.data);
  }
}
